var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotImportant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.36 12.48L10.008 8V4.8H12.088V8L11.72 12.48H10.36ZM11.896 15.84C11.6613 16.0747 11.3787 16.192 11.048 16.192C10.7173 16.192 10.4347 16.0747 10.2 15.84C9.96532 15.6053 9.84798 15.3227 9.84798 14.992C9.84798 14.6613 9.95998 14.3787 10.184 14.144C10.4187 13.9093 10.7067 13.792 11.048 13.792C11.3787 13.792 11.6613 13.9093 11.896 14.144C12.1307 14.3787 12.248 14.6613 12.248 14.992C12.248 15.3227 12.1307 15.6053 11.896 15.84Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotImportant);
export default __webpack_public_path__ + "static/media/not-important.aa913ba9c9f349ca5bcd179d87cecc4e.svg";
export { ForwardRef as ReactComponent };